import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
@safeCustomElement('mdc-post-analytics-card')
export class MdcPostAnalyticsCard extends LitElement {
  @property({ type: String, attribute: 'media-value' }) mediaValue = ''
  @property({ type: String }) reach = ''
  @property({ type: String }) impressions = ''

  static styles = css`
		:host {
			display: block;
			font-family: var(--typography-font-family-sans);
		}

		.mdc-post-analytics-card {
			display: flex;
			flex-direction: column;
			text-align: center;
			gap: 0.75rem;
			word-break: break-word;
		}

		.mdc-post-analytics-card p {
			margin: 0;
		}

		.mdc-post-analytics-card *,
		.mdc-post-analytics-card *::before,
		.mdc-post-analytics-card *::after {
			box-sizing: border-box;
		}

		.mdc-post-analytics-card__metric-value {
			font-size: 0.875rem;
			color: var(--color-functional-gray-black, #111111);
		}

		.mdc-post-analytics-card__metric-label {
			font-size: 0.6875rem;
			color: var(--color-functional-gray-400, #999999);
		}

		.mdc-post-analytics-card__metric {
			font-weight: 450;
			line-height: 1.3;
		}

		/* breakpoints.lg */
		@media (min-width: 1024px) {
			.mdc-post-analytics-card__metrics {
				display: flex;
				padding-top: 0.5rem;
				padding-bottom: 0.5rem;
			}

			.mdc-post-analytics-card__metrics > * + * {
				margin-left: 0.5rem;
				padding-left: 0.5rem;
				border-left: 1px solid var(--color-functional-gray-200, #e5e5e5);
			}

			.mdc-post-analytics-card__metric {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: flex-start;
				flex: 1;
				gap: 0.25rem;
			}
		}

		/* breakpoints.lg - 1 */
		@media (max-width: 1023px) {
			.mdc-post-analytics-card__metrics {
				padding-right: 0.5rem;
				padding-left: 0.5rem;
			}

			.mdc-post-analytics-card__metrics > *:first-child {
				padding-top: 0.5rem;
			}

			.mdc-post-analytics-card__metrics > *:last-child {
				padding-bottom: 0.5rem;
			}

			.mdc-post-analytics-card__metrics > * + * {
				margin-top: 0.5rem;
				padding-top: 0.5rem;
				border-top: 1px solid var(--color-functional-gray-200, #e5e5e5);
			}

			.mdc-post-analytics-card__metric {
				display: flex;
				justify-content: space-between;
				gap: 0.5rem;
			}
		}
	`

  render() {
    return html`
			<div class="mdc-post-analytics-card">
				<slot name="post-card"></slot>
				<div class="mdc-post-analytics-card__metrics">
					<div class="mdc-post-analytics-card__metric">
						<p class="mdc-post-analytics-card__metric-value">${this.mediaValue}</p>
						<p class="mdc-post-analytics-card__metric-label">Media Value</p>
					</div>
					<div class="mdc-post-analytics-card__metric">
						<p class="mdc-post-analytics-card__metric-value">${this.reach}</p>
						<p class="mdc-post-analytics-card__metric-label">Reach</p>
					</div>
					<div class="mdc-post-analytics-card__metric">
						<p class="mdc-post-analytics-card__metric-value">${this.impressions}</p>
						<p class="mdc-post-analytics-card__metric-label">Impressions</p>
					</div>
				</div>
			</div>
		`
  }
}
